/**
 * @generated SignedSource<<93f05824ed6a2e31f7d4660b075044c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddBlockPermanentlyRestartIfFailedContentConfigInput = {
  clientMutationId?: string | null | undefined;
  contentNodeId: string;
  maximumTries: number;
};
export type RestartIfFailedContentConfigEditor_AddBlockPermanentlyRestartIfFailedContentConfigMutation$variables = {
  input: AddBlockPermanentlyRestartIfFailedContentConfigInput;
};
export type RestartIfFailedContentConfigEditor_AddBlockPermanentlyRestartIfFailedContentConfigMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly addBlockPermanentlyRestartIfFailedContentConfig: {
        readonly contentNode: {
          readonly " $fragmentSpreads": FragmentRefs<"RestartIfFailedContentConfigEditor_TreeNodeFragment">;
        };
      } | null | undefined;
    };
  };
};
export type RestartIfFailedContentConfigEditor_AddBlockPermanentlyRestartIfFailedContentConfigMutation = {
  response: RestartIfFailedContentConfigEditor_AddBlockPermanentlyRestartIfFailedContentConfigMutation$data;
  variables: RestartIfFailedContentConfigEditor_AddBlockPermanentlyRestartIfFailedContentConfigMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RestartIfFailedContentConfigEditor_AddBlockPermanentlyRestartIfFailedContentConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddBlockPermanentlyRestartIfFailedContentConfigPayload",
                "kind": "LinkedField",
                "name": "addBlockPermanentlyRestartIfFailedContentConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "contentNode",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "RestartIfFailedContentConfigEditor_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RestartIfFailedContentConfigEditor_AddBlockPermanentlyRestartIfFailedContentConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddBlockPermanentlyRestartIfFailedContentConfigPayload",
                "kind": "LinkedField",
                "name": "addBlockPermanentlyRestartIfFailedContentConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "contentNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "typeDefinition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "restartIfFailedConfigs",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "configType",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isRestartIfFailedContentConfig"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "daysToBlock",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "BlockTemporarilyRestartIfFailedContentConfig",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "maximumTries",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "BlockPermanentlyRestartIfFailedContentConfig",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ContentTypeDefinition",
                            "abstractKey": "__isContentTypeDefinition"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "34d70243c7da671c5e32ca579e0442d1",
    "id": null,
    "metadata": {},
    "name": "RestartIfFailedContentConfigEditor_AddBlockPermanentlyRestartIfFailedContentConfigMutation",
    "operationKind": "mutation",
    "text": "mutation RestartIfFailedContentConfigEditor_AddBlockPermanentlyRestartIfFailedContentConfigMutation(\n  $input: AddBlockPermanentlyRestartIfFailedContentConfigInput!\n) {\n  Admin {\n    Tree {\n      addBlockPermanentlyRestartIfFailedContentConfig(input: $input) {\n        contentNode {\n          ...RestartIfFailedContentConfigEditor_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment BlockPermanentlyRestartIfFailedContentConfigForm_BlockPermanentlyRestartIfFailedContentConfigFragment on BlockPermanentlyRestartIfFailedContentConfig {\n  id\n  configType\n  maximumTries\n}\n\nfragment BlockPermanentlyRestartIfFailedContentConfigForm_TreeNodeFragment on TreeNode {\n  id\n}\n\nfragment BlockTemporarilyRestartIfFailedContentConfigForm_BlockTemporarilyRestartIfFailedContentConfigFragment on BlockTemporarilyRestartIfFailedContentConfig {\n  id\n  configType\n  daysToBlock\n}\n\nfragment BlockTemporarilyRestartIfFailedContentConfigForm_TreeNodeFragment on TreeNode {\n  id\n}\n\nfragment ProjectExtendRestartIfFailedContentConfigEditor_RestartIfFailedContentConfigFragment on RestartIfFailedContentConfig {\n  __isRestartIfFailedContentConfig: __typename\n  id\n  configType\n}\n\nfragment ProjectExtendRestartIfFailedContentConfigEditor_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      restartIfFailedConfigs {\n        __typename\n        id\n        configType\n      }\n    }\n  }\n}\n\nfragment RestartIfFailedContentConfigEditor_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ContentTypeDefinition {\n      __isContentTypeDefinition: __typename\n      restartIfFailedConfigs {\n        __typename\n        id\n        configType\n        ... on BlockTemporarilyRestartIfFailedContentConfig {\n          daysToBlock\n        }\n        ... on BlockPermanentlyRestartIfFailedContentConfig {\n          maximumTries\n        }\n        ...BlockPermanentlyRestartIfFailedContentConfigForm_BlockPermanentlyRestartIfFailedContentConfigFragment\n        ...BlockTemporarilyRestartIfFailedContentConfigForm_BlockTemporarilyRestartIfFailedContentConfigFragment\n        ...ProjectExtendRestartIfFailedContentConfigEditor_RestartIfFailedContentConfigFragment\n      }\n    }\n  }\n  ...BlockTemporarilyRestartIfFailedContentConfigForm_TreeNodeFragment\n  ...BlockPermanentlyRestartIfFailedContentConfigForm_TreeNodeFragment\n  ...ProjectExtendRestartIfFailedContentConfigEditor_TreeNodeFragment\n}\n"
  }
};
})();

(node as any).hash = "7eca3429ad9df4b0ae1ca776dfc68ea2";

export default node;
